import { render, staticRenderFns } from "./MostActiveSchoolDetailActiveStudent.vue?vue&type=template&id=4277c044&"
import script from "./MostActiveSchoolDetailActiveStudent.vue?vue&type=script&lang=js&"
export * from "./MostActiveSchoolDetailActiveStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
